export enum HoverEffect {
  BG_DARK = 'hover:brightness-90 hover:contrast-125',
  TEXT_DARK = 'hover:brightness-75',
}

export function getSimpleHoverClassNames(hoverEffect = HoverEffect.BG_DARK): string[] {
  return [hoverEffect];
}
